import { render, staticRenderFns } from "./locked-application-banner.vue?vue&type=template&id=6f20f4a0&scoped=true"
import script from "./locked-application-banner.vue?vue&type=script&lang=js"
export * from "./locked-application-banner.vue?vue&type=script&lang=js"
import style0 from "./locked-application-banner.vue?vue&type=style&index=0&id=6f20f4a0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f20f4a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f20f4a0')) {
      api.createRecord('6f20f4a0', component.options)
    } else {
      api.reload('6f20f4a0', component.options)
    }
    module.hot.accept("./locked-application-banner.vue?vue&type=template&id=6f20f4a0&scoped=true", function () {
      api.rerender('6f20f4a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/client-portal/js/modules/banners/locked-application-banner.vue"
export default component.exports